import { createStructuredSelector } from 'reselect';
import { selectAccountID, selectAccountName, selectAvailableBalance, selectCurrentBalance, selectCsrBusinessFunction } from '../../../../../../selectors/globalSelectors';

export const getTiffStates = (data) => data.tiffExchange;
export const getRecommendAnExchangeStates = (data) => data.recommendAnExchange;

export const getAccDataLoading = (data) => {
    const { accountData } = getRecommendAnExchangeStates(data);
    return accountData.isLoading
}

export const getAccData = (data) => {
    const { accountData } = getRecommendAnExchangeStates(data);
    return accountData.data
}

export const getFormDataSubmitted = (data) => {
    const { formDataSubmitted } = getTiffStates(data);
    return formDataSubmitted
}

export const getValueInFormChangeValue = (data) => {
    const { valueInFormChange } = getTiffStates(data);
    return valueInFormChange
}

export const getTiffAccDataLoading = (data) => {
    const { accountData } = getTiffStates(data);
    return accountData.isLoading
}

export const getAllPoolLoading = (data) => {
    const { toFrom } = getRecommendAnExchangeStates(data);
    return toFrom.isLoading
}

export const getAllPoolData = (data) => {
    const { toFrom } = getRecommendAnExchangeStates(data);
    return toFrom.data
}

export const getInputValues = (data) => {
    const { fromPool } = getTiffStates(data);
    return fromPool.data
}


export const getInputValuesLoading = (data) => {
    const { fromPool } = getTiffStates(data);
    return fromPool.isLoading
}


export const getTiffExchangeAmount = (data) => {
    const { tiffExchangeAmount } = getTiffStates(data);
    return tiffExchangeAmount
}


export const getPoolTableInto = (data) => {
    const { stepOne } = getTiffStates(data);
    return stepOne
}

export const getStepOneSet = (data) => {
    const { stepOneSet } = getTiffStates(data);
    return stepOneSet
}

export const getPoolTableFrom = (data) => {
    const { stepTwo } = getTiffStates(data);
    return stepTwo
}

export const getStepTwoSet = (data) => {
    const { stepTwoSet } = getTiffStates(data);
    return stepTwoSet
}

export const getSelectedTiffOption = (data) => {
    const { selectTiffOption } = getTiffStates(data);
    return selectTiffOption
}

export const getTiifInfoData = (data) => {
    const { tiffInfo } = getTiffStates(data);
    return tiffInfo.data
}

export const getTiifInfoLoading = (data) => {
    const { tiffInfo } = getTiffStates(data);
    return tiffInfo.isLoading
}


export const getTiffDisclaimer = (data) => {
    const { tiffDisclaimer } = getTiffStates(data);
    return tiffDisclaimer
}

export const getTiffPoolName = (data) => {
    const { tiffPoolName } = getTiffStates(data);
    return tiffPoolName
}

export const getPoolData = (data) => {
    const { poolData } = getRecommendAnExchangeStates(data);
    return poolData.singlePool
}

export const getPoolUf = (data) => {
    const { poolData } = getRecommendAnExchangeStates(data);
    return poolData.singleUF
}


export const getPoolModal = (data) => {
    const { poolData } = getRecommendAnExchangeStates(data);
    return poolData.modalPool
}

export const getModalUF = (data) => {
    const { poolData } = getRecommendAnExchangeStates(data);
    return poolData.modalUF
}

export const getPoolInfoDataLoading = (data) => {
    const { poolInfoData } = getTiffStates(data);
    return poolInfoData.isLoading
}

export const getPoolInfoData = (data) => {
    const { poolInfoData } = getTiffStates(data);
    return poolInfoData.data
}

export const getIsDisabled = (data) => {
    const { isDisabled } = getTiffStates(data);
    return isDisabled
}

export const getTiffDetails = (data) => {
    const { viewEditTiff } = getTiffStates(data);
    return viewEditTiff.data.singleExchange
}

export const getTiffDetailsLoader = (data) => {
    const { viewEditTiff } = getTiffStates(data);
    return viewEditTiff.isLoading
}

export const getIntoTotal = (data) => {
    const { intoTotal } = getTiffStates(data);
    return intoTotal
}

export const getExchangeAmount = (data) => {
    const { exchangeAmount } = getTiffStates(data);
    return exchangeAmount
}

export const getExpectedEchangeDate = (data) => {
    const { expectedEchangeDate } = getTiffStates(data);
    return expectedEchangeDate.data
}

export const getExpectedEchangeDateLoader = (data) => {
    const { expectedEchangeDate } = getTiffStates(data);
    return expectedEchangeDate.isLoading
}

export const getSubmitTransactionId = (data) => {
    const { submitTransactionId } = getTiffStates(data);
    return submitTransactionId
}

export const getFromTiffPoolDetails = (data) => {
    const { fromTiffPoolDetails } = getTiffStates(data);
    return fromTiffPoolDetails
}


export const getToTiffPoolDetails = (data) => {
    const { toTiffPoolDetails } = getTiffStates(data);
    return toTiffPoolDetails
}

export const getAllPoolFromLoading = (data) => {
    const { toFrom } = getTiffStates(data);
    return toFrom.isLoading
}

export const getAllPoolFromData = (data) => {
    const { toFrom } = getTiffStates(data);
    return toFrom.data
}

export const getDisableFromOption = (data) => {
    const { disableFromOption } = getTiffStates(data);
    return disableFromOption
}

export const getBeforeSubmitData = (data) => {
    const { beforeSubmitData } = getTiffStates(data);
    return beforeSubmitData
}


export const getAfterSubmitData = (data) => {
    const { afterSubmitData } = getTiffStates(data);
    return afterSubmitData
}

export const getTiffType = (data) => {
    const { tiffType } = getTiffStates(data);
    return tiffType
}

export const getCustomFeeForPool = data => {
    const { customFeeForPool } = getRecommendAnExchangeStates(data);
    return customFeeForPool;
}

export const TiffFormDerivedStates = createStructuredSelector({
    accountID: selectAccountID,
    accountName: selectAccountName,
    availableBalance: selectAvailableBalance,
    currentBalance: selectCurrentBalance,
    accDataLoading: getAccDataLoading,
    formDataSubmitted: getFormDataSubmitted,
    valueInFormChangeValue: getValueInFormChangeValue
});


export const TiffRecommendAnExchangeDerivedStates = createStructuredSelector({
    availableBalance: selectAvailableBalance,
    currentBalance: selectCurrentBalance,
    accDataLoading: getTiffAccDataLoading,
    allPoolLoading: getAllPoolLoading,
    allPoolData: getAllPoolData,
    inputValues: getInputValues,
    inputValuesLoading: getInputValuesLoading,
    tiffExchangeAmount: getTiffExchangeAmount,
    poolTableInto: getPoolTableInto,
    stepOneSet: getStepOneSet,
    poolTableFrom: getPoolTableFrom,
    stepTwoSet: getStepTwoSet,
    selectedTiffOption: getSelectedTiffOption,
    tiifInfoData: getTiifInfoData,
    tiifInfoLoading: getTiifInfoLoading,
    tiffDisclaimer: getTiffDisclaimer,
    tiffPoolName: getTiffPoolName,
    poolData: getPoolData,
    poolUf: getPoolUf,
    poolModal: getPoolModal,
    modalUF: getModalUF,
    poolInfoDataLoading: getPoolInfoDataLoading,
    poolInfoData: getPoolInfoData,
    isDisabled: getIsDisabled,
    getTiffDetails: getTiffDetails,
    intoTotal: getIntoTotal,
    exchangeAmount: getExchangeAmount,
    expectedEchangeDate: getExpectedEchangeDate,
    expectedEchangeDateLoader: getExpectedEchangeDateLoader,
    formDataSubmitted: getFormDataSubmitted,
    submitTransactionId: getSubmitTransactionId,
    fromTiffPoolDetails: getFromTiffPoolDetails,
    toTiffPoolDetails: getToTiffPoolDetails,
    allPoolFromLoading: getAllPoolFromLoading,
    allPoolFromData: getAllPoolFromData,
    disableFromOption: getDisableFromOption,
    valueInFormChangeValue: getValueInFormChangeValue,
    beforeSubmitData: getBeforeSubmitData,
    afterSubmitData: getAfterSubmitData,
    customFeeForPool: getCustomFeeForPool,
    csrBusinessFunction: selectCsrBusinessFunction
});

export const ViewEditFromTiffDerivedStates = createStructuredSelector({
    accountId: selectAccountID,
    accountName: selectAccountName,
    availableBalance: selectAvailableBalance,
    currentBalance: selectCurrentBalance,
    accDataLoading: getAccDataLoading,
    accDataPools: getAccData,
    inputValues: getInputValues,
    inputValuesLoading: getInputValuesLoading,
    tiffExchangeAmount: getTiffExchangeAmount,
    getTiffDetails: getTiffDetails,
    getTiffDetailsLoader: getTiffDetailsLoader,
    tiffType: getTiffType,
    expectedEchangeDate: getExpectedEchangeDate,
    expectedEchangeDateLoader: getExpectedEchangeDateLoader,
    exchangeAmount: getExchangeAmount,
    submitTransactionId: getSubmitTransactionId,
});

export const ViewEditIntoTiffDerivedStates = createStructuredSelector({
    accountId: selectAccountID,
    accountName: selectAccountName,
    availableBalance: selectAvailableBalance,
    currentBalance: selectCurrentBalance,
    accDataLoading: getAccDataLoading,
    accDataPools: getAccData,
    inputValues: getInputValues,
    inputValuesLoading: getInputValuesLoading,
    tiffExchangeAmount: getTiffExchangeAmount,
    getTiffDetails: getTiffDetails,
    getTiffDetailsLoader: getTiffDetailsLoader,
    tiffType: getTiffType,
    expectedEchangeDate: getExpectedEchangeDate,
    expectedEchangeDateLoader: getExpectedEchangeDateLoader,
    submitTransactionId: getSubmitTransactionId,
    intoTotal: getIntoTotal,
});

